<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!acompanhamentos || !acompanhamentos.length">
        Não foi encontrada posição da carteira em recuperação de crédito com os filtros informados.
    </div>

    <div *ngIf="acompanhamentos && acompanhamentos.length">
        <div *ngIf="dataHoraResultado" class="float-start letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-identificadorDocumento" scope="col">
                              <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'identificadorDocumento'"
                                [nomeAtributoExibicao]="'Id. documento'"
                                (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                            </th>

                            <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'agenteFinanceiroDestinatario'"
                                    [nomeAtributoExibicao]="'Agente financeiro'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-dataEnvio" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'dataEnvio'"
                                    [nomeAtributoExibicao]="'Data de envio'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-tipoDocumento" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'tipo'"
                                    [nomeAtributoExibicao]="'Tipo documento'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-competencia" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'competencia'"
                                    [nomeAtributoExibicao]="'Competência'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-periodoCompetencia" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'periodo'"
                                    [nomeAtributoExibicao]="'Período Competência'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>



                            <th id="col-status" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'estado'"
                                    [nomeAtributoExibicao]="'Status'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th scope="col" class="text-start">
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let acompanhamento of acompanhamentos" id="pointer"  [routerLink]="['/acompanhamento-documento-depr/detalhe', acompanhamento.id]" >
                            <td>{{ acompanhamento.identificadorDocumento }}</td>
                            <td *ngIf="!ehAgenteFinanceiro">{{ nomeAgenteFinanceiro(acompanhamento.cnpjAgenteFinanceiro) }}</td>
                            <td>{{ acompanhamento.dataEnvio | date: 'dd/MM/yyyy'}}</td>
                            <td>{{ nomeTipoDocumento(acompanhamento.tipo) }}</td>
                            <td>{{ acompanhamento.anoCompetencia }}</td>
                            <td>{{ nomePeriodo(acompanhamento.periodo) }}</td>
                            <td>{{ acompanhamento.estado.nomeEstado }}</td>
                            <td></td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>
